module.exports = __webpack_public_path__ + "static/media/Teresa Coulter Headshot_1713390618289.7a41a211.jpeg";